<template>
    <sections>
        <section-jumbo
            color="bg-gray-900"
            :image="jumbo.image"
            :imageSizes="jumbo.imageSizes"
            :imageSet="jumbo.imageSet"
            imageOpacity="opacity-50"
            :heading="$config.public.siteName"
            headingColor="text-white"
            :content="'<p>' + $config.public.siteStrapline + '</p>'"
            contentColor="text-gray-200"
            :textCentered="false"
        ></section-jumbo>
        <section-text heading="About Us" heading-component="h2" content="<article-about-us />"></section-text>
        <section-image
            color="bg-zinc-50"
            :image="$config.public.images + 'seo-work.jpg'"
            heading="Improve SEO and beat the competition"
            heading-component="h2"
            content="<article-seo-work />"
            buttonText="Contact Us"
            buttonRoute="/contact"
        ></section-image>
        <section-image
            :flip="true"
            :image="$config.public.images + 'native-speakers.jpg'"
            heading="Experienced team of native speakers"
            heading-component="h2"
            content="<article-native-speakers />"
            buttonText="Contact Us"
            buttonRoute="/contact"
        ></section-image>
        <section-image
            color="bg-zinc-50"
            :image="$config.public.images + 'project-management.jpg'"
            heading="Project management"
            heading-component="h2"
            content="<article-project-management />"
            buttonText="Contact Us"
            buttonRoute="/contact"
        ></section-image>
        <section-image
            :flip="true"
            :image="$config.public.images + 'why-us.jpg'"
            heading="Why us?"
            heading-component="h2"
            content="<article-why-us />"
            buttonText="Contact Us"
            buttonRoute="/contact"
        ></section-image>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const jumbo = {
    imageSizes: '100vw',
    imageSet: `
        ${$config.public.images}gsc-editorial-200.webp 200w,
        ${$config.public.images}gsc-editorial-581.webp 581w,
        ${$config.public.images}gsc-editorial-853.webp 853w,
        ${$config.public.images}gsc-editorial-1126.webp 1126w,
        ${$config.public.images}gsc-editorial-1200.webp 1200w
    `,
    image: `${$config.public.images}gsc-editorial.jpg`,
};

useSeo().buildHead({
    title: $config.public.siteName,
    description: $config.public.siteStrapline,
    index: true,
});
</script>
